import { useState } from "react";

export function useFileError() {
  const [fileError, setFileError] = useState<string | undefined>();

  const clearFileError = () => setFileError(undefined);

  return { fileError, setFileError, clearFileError };
}
